import { useState, useEffect } from "react";
import BackButton from "../utils/backButton";
import { useNavigate } from "react-router-dom";
import { GetGlobalColor } from "../utils/globalColors";
import Spinner from '../utils/spinner';
const Avatars = () => {
  const [availableAvatars, setAvailableAvatars] = useState();
  const token = localStorage.getItem('userToken');
  const gameId = localStorage.getItem('gameId');
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const color = GetGlobalColor();
  const [loading, setLoading] = useState(true);

  const getAvailableAvatars = async () => {

    try {
      const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/game/getGameAvatars`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ token: token, gameId: gameId }),
      });

      const result = await response.json();
      if (result.available_avatars) {
        console.log("Response from API:", result);
        setAvailableAvatars(result.available_avatars)
      }

    } catch (error) {
      console.error("Error calling API:", error);
      setError("Napaka poskusite ponovno!");
    }
    finally {
      setLoading(false);
    }
  };

  const setNewAvatar = async (avatar) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/game/setGameAvatar`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ token: token, gameId: gameId, avatarName: avatar }),
      });

      if (response.status === 204) {
        navigate("/Game");
      }

    } catch (error) {
      console.error("Error calling API:", error);
    }
    finally {
      setError("Napaka poskusite ponovno!");
    }
  };

  useEffect(() => {
    getAvailableAvatars();
  }, []);

  return (
    <>
      <div className={`box card-bg-${color}`}>
        {error && <p className="text-red-500 mb-4">{error}</p>}
        {loading &&
          <Spinner />
        }
        <p className="text-xl font-bold wtext mb-4">Nastavi novega avatarja</p>
        <div className="flex flex-wrap justify-center gap-4">
          {availableAvatars && availableAvatars.map((d, index) => (
            <i key={index} className={`${d} text-3xl m-2`} onClick={() => setNewAvatar(d)}></i>
          ))}
        </div>
      </div>
    </>
  )
}

export default Avatars;

